/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import NflEnded from '../partials/NflEnded';
import NflLiveGameStats from '../partials/NflLiveGameStats';
import NflLiveGameStatsDetailed from '../partials/NflLiveGameStatsDetailed';
import SportGame from './Sport';

function NflGame(props) {
    return (
        <SportGame
            gameStatsComponent={NflLiveGameStats}
            gameStatsDetailedComponent={NflLiveGameStatsDetailed}
            endedComponent={NflEnded}
            {...props}
        />
    );
}

export default NflGame;
